import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TAnalyticsEventSenderOnMount, IDeps } from './models';
import { AnalyticsEventSenderOnMount as Component } from './analytics-event-sender-on-mount';

export const AnalyticsEventSenderOnMount = createWidget<IDeps, TAnalyticsEventSenderOnMount>({})(
    Component
);
